
export const IdType = [
  {
    id: '099',
    value: '其他法人或其他组织有效证件'
  },
  {
    id: '111',
    value: '居民身份证'
  },
  {
    id: '112',
    value: '临时居民身份证'
  },
  {
    id: '113',
    value: '户口簿'
  },
  {
    id: '114',
    value: '中国人民解放军军官证'
  },
  {
    id: '115',
    value: '中国人民武装警察部队警官证'
  },
  {
    id: '117',
    value: '出生医学证明'
  },
  {
    id: '118',
    value: '中国人民解放军士兵证'
  },
  {
    id: '119',
    value: '中国人民武装警察部队士兵证'
  },
  {
    id: '120',
    value: '中国人民解放军文职人员证'
  },
  {
    id: '122',
    value: '中国人民武装警察部队文职人员证'
  },
  {
    id: '154',
    value: '居住证'
  },
  {
    id: '411',
    value: '外交护照'
  },
  {
    id: '412',
    value: '公务护照'
  },
  {
    id: '413',
    value: '公务普通护照'
  },
  {
    id: '414',
    value: '普通护照'
  },
  {
    id: '415',
    value: '旅行证'
  },
  {
    id: '418',
    value: '外国人旅行证'
  },
  {
    id: '511',
    value: '台湾居民来往大陆通行证'
  },
  {
    id: '516',
    value: '港澳居民来往内地通行证'
  },
  {
    id: '553',
    value: '外国人永久居留身份证'
  },
  {
    id: '554',
    value: '外国人居留证或居留许可'
  },
  {
    id: '555',
    value: '外国人临时居留证'
  },
  {
    id: '791',
    value: '外交人员身份证明'
  },
  {
    id: '792',
    value: '境外人员身份证明'
  },
  {
    id: '813',
    value: '驻华机构证明'
  },
  {
    id: '821',
    value: '营业执照'
  },
  {
    id: '830',
    value: '律师事务所执业许可证'
  },
  {
    id: '999',
    value: '其他'
  }
]
// 非常不满意
export const veryDissatisfied = [
  '被要求提交办事指南未列明的申报材料',
  '承诺在线收取申报材料实际无法收取',
  '没有在承诺的时间内办理完该事项',
  '需要到位于实体大厅以外的办公场所提交申报材料',
  '到大厅现场的次数和承诺的不一致',
  '被要求在实体大厅以外的场所先办理，再到窗口重新申报或者线上重复提交',
  '在办事指南列明的审批条件之外附加新的审批条件'
]
// 不满意
export const dissatisfied = [
  '办事指南列出的申报材料没有提供样本',
  '不能够以清单的方式一次性完整告知要提交的申报材料等相关信息',
  '同样内容的证明材料已向该受理部门提交过，却被要求再次提交',
  '办理完该事项需要到窗口2次以上',
  '实体大厅没有配备现场排队叫号系统',
  '在线预约办理后到实体大厅重复取号排队'
]
// 基本满意
export const basicDissatisfied = [
  '按照办事指南的指引能够顺利完成申报事项的办理',
  '能够做到一张清单告知所要提交的全部申报材料',
  '该事项只进一个实体大厅就能够办完',
  '该事项在承诺的时间内办完',
  '跑2次窗口即可办完该事项',
  '实体大厅现场实行排队叫号办理'
]
// 满意
export const satisfaction = [
  '该事项只需要填写一张表单就可以完成申报',
  '该事项可以在线提交全部申报材料，到窗口核验原件，实现最多跑一次窗口',
  '该事项可以通过自助机办理，但只限于工作时间',
  '该事项可以在线预约办理'
]
// 非常不满意
export const verySatisfied = [
  '该事项在综合窗口收件，一个窗口受理，一次就能办成',
  '该事项可以实行容缺受理',
  '办理该事项不需要提交由政府部门出具的各种证明材料',
  ' 办理该事项不需要提交政府部门出具的各类证照批文',
  '该事项无需到实体大厅办理，可以在线上传全部申报材料，不用到窗口核验',
  '该事项可以使用自助机在任何时候办理',
  '该事项可以在本市范围内就近的实体大厅办理',
  '该事项可以在本省范围内就近的实体大厅办理',
  '该事项可以在全国范围内就近的实体大厅办理'
]
